var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopwatchPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0833,
    cy: 11.0833,
    r: 5.08331,
    stroke: "#808086"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82416 9.67119C8.82416 9.40802 8.82416 9.27644 8.86715 9.17264C8.92448 9.03425 9.03443 8.92429 9.17283 8.86697C9.27662 8.82397 9.40821 8.82397 9.67138 8.82397C9.93455 8.82397 10.0661 8.82397 10.1699 8.86697C10.3083 8.92429 10.4183 9.03425 10.4756 9.17264C10.5186 9.27644 10.5186 9.40802 10.5186 9.67119V12.4953C10.5186 12.7584 10.5186 12.89 10.4756 12.9938C10.4183 13.1322 10.3083 13.2422 10.1699 13.2995C10.0661 13.3425 9.93455 13.3425 9.67138 13.3425C9.40821 13.3425 9.27662 13.3425 9.17283 13.2995C9.03443 13.2422 8.92448 13.1322 8.86715 12.9938C8.82416 12.89 8.82416 12.7584 8.82416 12.4953V9.67119Z",
    stroke: "#808086"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.648 9.67119C11.648 9.40802 11.648 9.27644 11.691 9.17264C11.7483 9.03425 11.8583 8.92429 11.9967 8.86697C12.1005 8.82397 12.2321 8.82397 12.4952 8.82397C12.7584 8.82397 12.89 8.82397 12.9938 8.86697C13.1322 8.92429 13.2421 9.03425 13.2995 9.17264C13.3424 9.27644 13.3424 9.40802 13.3424 9.67119V12.4953C13.3424 12.7584 13.3424 12.89 13.2995 12.9938C13.2421 13.1322 13.1322 13.2422 12.9938 13.2995C12.89 13.3425 12.7584 13.3425 12.4952 13.3425C12.2321 13.3425 12.1005 13.3425 11.9967 13.2995C11.8583 13.2422 11.7483 13.1322 11.691 12.9938C11.648 12.89 11.648 12.7584 11.648 12.4953V9.67119Z",
    stroke: "#808086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchPause);
export default __webpack_public_path__ + "static/media/Stopwatch Pause.3c12ddecbe76d99d7e1151ca033d998b.svg";
export { ForwardRef as ReactComponent };